import type { Home } from '@lmc/ts-common'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import TeamMemberProfileScreen from './TeamMemberProfileScreen'
import TeamMemberProfileScreenV2 from './TeamMemberProfileScreenV2'

export const TeamMemberProfileScreenRedirect: FC = () => {
  const home = useSelector(
    (state: { global: { home: Home } }) => state.global.home
  )
  const { hasRota } = useHomeType()
  const flags = useFeatureFlags({
    flagNames: ['team_member', 'keyworkers', 'team_profile_redesign']
  })?.data

  // The redesigned screen reads everything it needs from Redux itself, so it
  // takes no props. The legacy screen still relies on these flag-derived props.
  if (flags?.team_profile_redesign?.enabled) {
    return <TeamMemberProfileScreenV2 />
  }

  const teamMemberEnabled = flags?.team_member?.enabled
  const keyworkersEnabled =
    flags?.keyworkers?.enabled && home?.features?.goals?.enabled

  return (
    <TeamMemberProfileScreen
      teamMemberEnabled={teamMemberEnabled}
      isRosteringBetaEnabled={hasRota}
      keyworkersEnabled={keyworkersEnabled}
    />
  )
}
